<template>
  <div class="indexPageBox">
    <div class="bannerBox1">
      <HeaderCom></HeaderCom>
      <div style="height: 520px">
        <div class="banner_item" style="background-image: url('static/image/pe_banner.png');">
          <div class="banner_item1_content">
            <p>安管通·消管通管理系统</p>
            <p class="txt1">
              通过规范人的行为，监控物的状态，帮助社会重点单位解决日常
              安全生产及消防安全自主管理问题
            </p>
            <div class="item1_infoBox pe_btn">
              立即申请
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part1Box">
      <div class="part1_content">
        <div class="part1_header">
          <span>方案简介</span>
          <span>构建智慧安全应急新生态</span>
        </div>
        <div class="part1_section">
          <div>
            <span>“安管通/消管通”消防自主管理系统</span>
            <span></span>
            <span>通过规范人的行为，监控物的状态，帮助社会重点单位解决日常安全生产及消防安全自主管理问题，包括日常消防检查、隐患实时上报、隐患整改、应急救援、隐患类别(区域)统计等功能，并通过”定人、定时间、定位置、定标准”的四定原则，结合大数据和人工智能图像识别、机器学习、智能语音交互等技术达到：全面掌管、快速响应、实时感知、分析预测的目的，全面落实社会单位消防安全主体责任、实行智慧化安全管理工作!</span>
          </div>
        </div>
      </div>
    </div>
    <div class="part3Box">
      <div class="part3_content">
        <div class="part3_tabs">
          <div class="part3_tab1" :class="{'activeTab':isActive == 1}" @click="handleClick(1)">
            业务功能
            <span class="activeLine" v-show="isActive == 1"></span>
          </div>
          <div class="part3_tab1" :class="{'activeTab':isActive == 2}" @click="handleClick(2)">
            数据信息采集
            <span class="activeLine activeLine1"   v-show="isActive == 2"></span>
          </div>
        </div>
        <div>
          <div class="part3_tab_content" v-show="isActive == 1">
            <div class="part3_tab_contentInfo">
              <div class="part3_tab_InfoBox1">
                <div class="part3_tab_ItemCell">
                  <span class="part3_tab_txt1"></span>
                  <span class="part3_tab_txt2">多网融合：</span>
                  <span>物防</span>
                  <span class="part3_tab_txt2">+</span>
                  <span>技防——报警联动</span>
                </div>
                <div class="part3_tab_InfoBox2">
                  <div>
                    <img src="static/image/pe_function_1.png" alt="">
                  </div>
                  <p class="part3_tab_txt2">设备24h感知预防更智能</p>
                  <p>消防水箱液位监测</p>
                  <p>报警主机火警报警器</p>
                  <p>烟感、温感、可燃气</p>
                  <p>电力火灾探测器</p>
                  <p>消防喷淋、消防栓最不利点水塔监测</p>
                  <p>消防通道监控</p>
                  <p>单位内部时评调用巡检</p>
                </div>
              </div>
              <div class="part3_tab_InfoBox1">
                <div class="part3_tab_ItemCell">
                  <span class="part3_tab_txt1"></span>
                  <span class="part3_tab_txt2">一个移动端：</span>
                  <span>人防</span>
                  <span class="part3_tab_txt2">+</span>
                  <span>技防——AI四定</span>
                </div>
                <div class="part3_tab_InfoBox2">
                  <div>
                    <img src="static/image/pe_function_2.png" alt="">
                  </div>
                  <p class="part3_tab_txt2">人员全天在线管理更便捷</p>
                  <p>消管通安全管理</p>
                  <p>单网络化检查</p>
                  <p>消防隐患随手发</p>
                  <p>隐患治理、卫星消防站应急联动</p>
                </div>
              </div>
              <div class="part3_tab_InfoBox1">
                <div class="part3_tab_ItemCell">
                  <span class="part3_tab_txt1"></span>
                  <span class="part3_tab_txt2">可视化：</span>
                  <span>指挥系统-应急管理</span>
                </div>
                <div class="part3_tab_InfoBox2">
                  <div>
                    <img src="static/image/pe_function_3.png" alt="">
                  </div>
                  <p class="part3_tab_txt2">联动应急指挥处理更及时</p>
                  <p>监控报警</p>
                  <p>单位内部信息</p>
                  <p>单位周边信息</p>
                  <p>灭火路线显示</p>
                  <p>周边视频调用 </p>
                </div>
              </div>
            </div>
          </div>
          <div class="part3_tab_content" v-show="isActive == 2">
            <div class="part3_tabImg">
              <img src="static/image/pe_information.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="part2Box">
      <div class="part2_content">
        <div class="part2_header">
          <span class="part2_header_txt1">解决方案</span>
          <span class="part2_header_txt2">构建智慧安全应急新生态</span>
        </div>
        <div class="part2_content_box">
          <div>
            <img src="static/image/pe_programme.png" alt="">
          </div>
          <div class="part2_box_middle">
            <img src="static/image/pe_point.png" alt="">
          </div>
          <div class="part2_box_right">
            <div class="part2_box_txt1" style="background-image: url('static/image/pe_box.png')">
              远程巡检
            </div>
            <div class="part2_right_txt">
              <div>
                <span class="part3_tab_txt1"></span>
                <span class="part2_right_txt1">单位基本信息（名称、电话、联系人、分类、危险源）</span>
              </div>
              <div>
                <span class="part3_tab_txt1"></span>
                <span class="part2_right_txt1">单位周边信息（水源位置、微型站位置、周边摄像头）</span>
              </div>
              <div>
                <span class="part3_tab_txt1"></span>
                <span class="part2_right_txt1">片区微型消防站情况（值班人、联系人、地址）</span>
              </div>
              <div>
                <span class="part3_tab_txt1"></span>
                <span class="part2_right_txt1">周围及内部监控摄像头调用</span>
              </div>
            </div>
            <div class="part2_box_txt1" style="background-image: url('static/image/pe_box.png')">
              隐患处置
            </div>
            <div class="part2_right_cell">
              <div class="part2_cell_item1">
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">监控调用核实隐患</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">一键呼叫责任人</span>
                </div>
              </div>
              <div class="part2_cell_item1">
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">隐患整改通知</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">隐患整改核查</span>
                </div>
              </div>
            </div>
            <div class="part2_box_txt1" style="background-image: url('static/image/pe_box.png')">
              应急指挥
            </div>
            <div class="part2_right_cell">
              <div class="part2_cell_item1">
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">起火点情况</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">周边监控调取</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">内部监控调取</span>
                </div>
              </div>
              <div class="part2_cell_item1">
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">最近水源取水路线</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">微型站支援路线</span>
                </div>
                <div>
                  <span class="part3_tab_txt1"></span>
                  <span class="part2_right_txt1">消防车、消防员位置</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>全面感知联控</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_control.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>视频监控联动感知接入</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_video.png" alt="">
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt2">收到报警信息，通过手机或电脑打开火灾附近摄像头进行火警核实</span>
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt2">日常可通过视频摄像头进行视频巡检</span>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>AI四定落实岗位职责</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_points.png" alt="">
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt3">不同工种</span>
          <p class="part4_item_txt4">一个重点部位只张贴一张MIP定位码，不同工种人员的工作内容不同</p>
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt3">不同级别</span>
          <p class="part4_item_txt4">同一工种，不同管理级别的人工作内容不同</p>
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt3">不同级别</span>
          <p class="part4_item_txt4">同一工种，不同级别的人的不同权限的工作内容也不同</p>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>重点部位示例</span>
        </div>
        <div class="part4_itemImp">
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_1.png" alt="">
            </div>
            <p class="part4_impBox_txt1">设施维护保养</p>
            <p>消防设施</p>
            <p>电梯</p>
            <p>供电设施</p>
            <p>空调</p>
            <p>给排水</p>
            <p>照明设施</p>
          </div>
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_2.png" alt="">
            </div>
            <p class="part4_impBox_txt1">巡检、值班</p>
            <p>防火巡查</p>
            <p>消防设施巡检</p>
            <p>违规用电</p>
            <p>照明设施</p>
            <p>夜间防盗</p>
            <p>环境卫生</p>
            <p>消控值班</p>
          </div>
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_3.png" alt="">
            </div>
            <p class="part4_impBox_txt1">店铺自检</p>
            <p>店铺用电</p>
            <p>库房用电</p>
            <p>消防设施</p>
            <p>顾客安全</p>
          </div>
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_4.png" alt="">
            </div>
            <p class="part4_impBox_txt1">物业店铺管理</p>
            <p>仓库失火</p>
            <p>消防设施</p>
            <p>消防通道</p>
          </div>
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_5.png" alt="">
            </div>
            <p class="part4_impBox_txt1">餐馆自查</p>
            <p>用火用气安全</p>
            <p>通道畅通</p>
            <p>消防设施</p>
            <p>烟道清洗</p>
          </div>
          <div class="part4_impBox">
            <div>
              <img src="static/image/pe_Position_6.png" alt="">
            </div>
            <p class="part4_impBox_txt1">餐馆管理</p>
            <p>用火用气安全</p>
            <p>消防通道</p>
            <p>消防设施</p>
            <p>烟道检查</p>
            <p>食品卫生</p>
            <p>合规经营</p>
          </div>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>移动端应急报警处理</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_mobile.png" alt="">
        </div>
        <div class="part4_itemTxt">
          <img src="static/image/pe_message.png" alt="">
          <span class="part4_item_txt3 part4_item_txt3Color">智能外呼电话/智能短信推送</span>
          <p class="part4_item_txt4 part4_item_txt4Space">设备异常自动外呼责任人，自动告警短信推送，短信联通设备现场视频，设备核实反馈记录</p>
        </div>
        <div class="part4_itemTxt">
          <img src="static/image/pe_WeChat.png" alt="">
          <span class="part4_item_txt3 part4_item_txt3Color">微信公众号/微信小程序</span>
          <p class="part4_item_txt4 part4_item_txt4Space">物联传感设备状态查看，警情确认，责任心管理，设备警情记录</p>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content">
        <div class="part3_tab_contentTxt1">
          <span class="part4_squ"></span>
          <span>紧急报警与处置策略</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_video.png" alt="">
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt2">一旦云平台检测到消防设备报警，回立即给报警设备所在区域的责任人（一人或多人），拨打报警电话、发送报警短信</span>
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt2">同时可以通过短信链接，实时查看消防设备周边的监控视频</span>
        </div>
        <div class="part4_itemTxt">
          <span class="part3_tab_txt1"></span>
          <span class="part4_item_txt2">警情确认后，通过反馈链接予以反馈报警元婴，用于数据存储和分析研判</span>
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content part4_contentSpace">
        <div class="part1_header">
          <span>移动端截图</span>
          <span>构建智慧安全应急新生态</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_screenshot_1.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content part4_contentSpace">
        <div class="part1_header">
          <span>数据墙汇聚</span>
          <span>构建智慧安全应急新生态</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_screenshot_2.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content part4_contentSpace">
        <div class="part1_header">
          <span>应用场景</span>
          <span>构建智慧安全应急新生态</span>
        </div>
        <div>
          专注各场所智慧消防整体设计、实施及运维
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_scene.png" alt="">
        </div>
      </div>
    </div>
    <div class="part4Box">
      <div class="part4_content part4_contentSpace">
        <div class="part1_header">
          <span>系统优势</span>
          <span>切实落实单位安全生产主体责任</span>
        </div>
        <div class="part4_itemImg">
          <img src="static/image/pe_polygon.png" alt="">
        </div>
      </div>
    </div>
    <div class="part5Box">
      <div class="part5_content">
        <div class="part5_content_box1">
          <div class="part1_header">
            <span>客户案例</span>
            <span>全面推开将为科学高效监管提供新思路</span>
          </div>
        </div>
        <div class="part5_item">
          <div class="part5_txtBox">
            <p class="part5_item_txt1">海口美兰国际机场（交通枢纽）</p>
            <p class="part5_item_txt2"></p>
            <p class="part5_item_txt3">系统帮助海口美兰机场实现了诸多的独特功能(例如：安全台账建立、设定工作标准、人员权限管理、查检查任务、安全排查落实、随手拍、隐患整改闭环、物联网接入、统计查询、大数据墙等)，“消管通”系统在机场日常安全检查中发挥了全员参与的重要作用，截止到2019年5月20日，共查出18项安全隐患，整改完成16项，隐患发现率提高了30%，整改完成率比以往提高了70%。</p>
          </div>
          <div class="part5_itemImg">
            <img src="static/image/pe_case_1.png" alt="">
          </div>
        </div>
        <div class="part5_item1">
          <img src="static/image/pe_case_Haikou.png" alt="">
        </div>
        <div>
          <p class="part5_item_txt1">南京新街口百货公司(商业综合体)</p>
          <p class="part5_item_txt2"></p>
          <p class="part5_item_txt4">南京新百位于南京市中心最繁华地段新街口，自1952年8月创建至今，已经具有60多年的历史，是一家老字号大型百货零售企业、中国十大百货商店之一和南京市第一家商业企业股票上市公司。</p>
        </div>
        <div class="part5_item2">
          <div>
            <img src="static/image/pe_company.png" alt="">
          </div>
          <div class="part5_item2txtBox">
            <div class="part5_item2_cell">
              <div>
                <span class="part5_item2Squ"></span>
                <span>新百管控面积17万平方</span>
              </div>
              <div>
                <span class="part5_item2Squ"></span>
                <span>共设置检查部位1837个</span>
              </div>
            </div>
            <div class="part5_item2_cell">
              <div>
                <span class="part5_item2Squ"></span>
                <span>使用了1811张mip码</span>
              </div>
              <div>
                <span class="part5_item2Squ"></span>
                <span>监管3535项工作内容</span>
              </div>
            </div>
            <div class="part5_item2_cell">
              <div>
                <span class="part5_item2Squ"></span>
                <span>巡查账号2144个</span>
              </div>
              <div>
                <span class="part5_item2Squ"></span>
                <span>自检工作2371条</span>
              </div>
            </div>
            <div class="part5_item2_cell">
              <div>
                <span class="part5_item2Squ"></span>
                <span>新工作完成率99%以上</span>
              </div>
              <div>
                <span class="part5_item2Squ"></span>
                <span>整改完成率99%以上</span>
              </div>
            </div>
          </div>
        </div>
        <div>
          <p class="part5_item_txt1">中关村智造大街(智慧园区)</p>
          <p class="part5_item_txt2"></p>
          <p class="part5_item_txt4">中关村智造大街，位于五道口清华大学东南门，是在北京市政府、中关村管委会及各委办局支持下，打造的围绕智能制造产业生态中试基地，成为引领*中国制造2025”*国家双创基地”创新高地</p>
        </div>
        <div class="part5_item2">
          <div class="part5_item2txtBox part5_item3">
            <div class="part5_item2_cell">
              <div class="part5_item2_txt1">
                <span class="part5_item2Squ"></span>
                <span>物防联网：消管通系统接入水压传感器、液位探测器、独立式感烟探测器、消控报警主机、视频监控服务器(50路)</span>
              </div>
            </div>
            <div class="part5_item2_cell">
              <div class="part5_item2_txt1">
                <span class="part5_item2Squ"></span>
                <span>人防巡查：消管通系统管控MIP：611张，巡查人员：28人，管控内容1164项</span>
              </div>
            </div>
            <div class="part5_item2_cell">
              <div class="part5_item2_txt1">
                <span class="part5_item2Squ"></span>
                <span>隐患闭环：消管通系统发现一般隐患4次，严重隐患18次。</span>
              </div>
            </div>
          </div>
          <div>
            <img src="static/image/pe_case_2.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <RegisterCom></RegisterCom>
    <FooterCom></FooterCom>
  </div>
</template>

<script>
  import HeaderCom from "../common/headerCom"
  import FooterCom from "../common/footerCom"
  import RegisterCom from "../common/registerCom"
  export default {
    name: "pipeEliminator",
    components: {HeaderCom, FooterCom,RegisterCom},
    data(){
      return{
        isActive:1,

      }
    },
    methods: {
      handleClick(index) {
        this.isActive = index;
      }
    }
  }
</script>

<style scoped>
  @import  '../../assets/css/bannerCom.css';
  .pe_btn{
    background:rgba(56,64,180,1);
  }
  .part1Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part1_content{
    width: 1200px;
    box-sizing: border-box;
    padding: 60px 0 0 0;
  }
  .part1_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .part1_header>span:nth-of-type(1){
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part1_header>span:nth-of-type(2){
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 30px 0 80px 0;
  }
  .part1_section{
    width: 100%;
    box-sizing: border-box;
    display: flex;
  }
  .part1_section>div:nth-of-type(1){
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    box-sizing: border-box;
    padding: 0 0 40px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(1){
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(2){
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    box-sizing: border-box;
    margin: 30px 0;
  }
  .part1_section>div:nth-of-type(1)>span:nth-of-type(3){
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
  }
  .part2Box{
    width:100%;
    height:960px;
    background:rgba(238,242,254,1);
    display: flex;
    justify-content: center;
  }
  .part2_content{
    width: 1200px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;

  }
  .part2_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    padding: 65px 0 0 0;
    flex-direction: column;
    align-items: center;
  }
  .part4_header{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }
  .part2_header_txt1{
    font-size:28px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
  }
  .part2_header_txt2{
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    box-sizing: border-box;
    padding: 20px 0 55px 0;
  }
  .part2_content_box{
    width: 100%;
    display: flex;
  }
  .part2_box_middle{
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 95px;

  }
  .part2_box_right{
    flex: 1;
  }
  .part2_box_txt1{
    width:178px;
    height:62px;
    font-size:20px;
    font-family:Microsoft YaHei;
    font-weight:400;
    color:rgba(240,147,51,1);
    line-height:30px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .part2_right_txt{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part2_right_txt>div{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part2_right_cell{
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 10px 0;
  }
  .part2_cell_item1{
    flex: 1;
  }
  .part2_cell_item1>div{
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part2_right_txt1{
    display: inline-block;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 0 20px;
  }
  .part2_header_txt3{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 0 60px 0;
  }
  .part3Box,.part4Box{
    width: 100%;
    display: flex;
    justify-content: center;
    background: #ffffff;
  }
  .part3_content{
    width: 1200px;
    box-sizing: border-box;
    padding:0 0 60px 0;
  }
  .part3_tabs{
    width: 100%;
    box-sizing: border-box;
    padding: 0 100px;
    border-bottom: 1px solid rgba(228,228,228,0.99);
    display: flex;
  }
  .part3_tab1{
    width: 30%;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    box-sizing: border-box;
    padding: 20px 0;
    position: relative;
    cursor: pointer;
  }
  .activeTab{
    color: #2A62FF;
  }
  .activeLine{
    position: absolute;
    width:60px;
    height:2px;
    background:rgba(42,98,255,1);
    bottom: -2px;
    left: 3%;
  }
  .activeLine1{
    left: 9%;
  }
  .part3_tab_content{
    width: 100%;
    box-sizing: border-box;
    padding: 40px 0;
  }
  .part3_tab_contentTxt1{
    font-size:24px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(42,98,255,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 60px 0 30px 0;
  }
  .part4_squ{
    display: inline-block;
    width:10px;
    height:10px;
    background:rgba(42,98,255,1);
    border-radius:50%;
    margin: 0 20px 0 0;
  }
  .part3_tab_contentTxt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
    display: inline-block;
    box-sizing: border-box;
  }
  .part3_tab_contentInfo{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
  }
  .part3_tab_InfoBox1{
    width: 360px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
  }
  .part3_tab_ItemCell{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color: #3B4A75;
    line-height:30px;
    box-sizing: border-box;
    padding: 20px 0;
  }
  .part3_tab_txt1{
    display: inline-block;
    width:10px;
    height:10px;
    border:2px solid rgba(42,98,255,1);
    border-radius:50%;
  }
  .part3_tab_txt2{
    color:rgba(42,98,255,1);
  }
  .part3_tab_InfoBox2{
    width:100%;
    height:585px;
    background:rgba(240,240,240,1);
    display: flex;
    align-items: center;
    flex-direction: column;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part3_tab_InfoBox2>div{
    box-sizing: border-box;
    padding: 20px 0;
  }
  .part3_tab_InfoBox2>p{
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part4_content{
    width: 1200px;
    box-sizing: border-box;
  }
  .part4_itemImg{
    text-align: center;
  }
  .part4_item_txt2{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    margin: 0 0 0 20px;
  }
  .part4_itemTxt{
    width: 100%;
    box-sizing: border-box;
    padding: 10px 0;
  }
  .part4_item_txt3{
    display: inline-block;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(42,98,255,1);
    line-height:30px;
    margin: 0 0 0 20px;
  }
  .part4_item_txt4{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    line-height:30px;
    padding: 0 0 0 30px;
  }
  .part4_itemImp{
    width: 100%;
    display: flex;
    justify-content: space-between;
  }
  .part4_impBox{
    width:180px;
    height:352px;
    background:rgba(238,242,254,1);
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(143,149,169,1);
    padding: 20px 0 0 0;
    line-height: 30px;
  }
  .part4_impBox>p{
    box-sizing: border-box;
  }
  .part4_impBox_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part4_item_txt3Color{
    vertical-align: top;
    font-size:20px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part4_item_txt4Space{
    padding: 0 0 0 63px;
  }
  .part4_contentSpace{
    box-sizing: border-box;
    padding: 60px 0;
  }
  .part4_header_txt1{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 25px 0;
  }
  .part5Box{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  }
  .part5_content{
    width: 1200px;
    box-sizing: border-box;
  }
  .part5_item{
    width: 100%;
    box-sizing: border-box;
    display: flex;
  }
  .part5_txtBox{
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part5_item_txt1{
    font-size:20px;
    font-family:PingFang SC;
    font-weight:bold;
    color:rgba(40,52,87,1);
    line-height:30px;
  }
  .part5_item_txt2{
    width:30px;
    height:3px;
    background:rgba(42,98,255,1);
    margin: 20px 0;
  }
  .part5_item_txt3{
    width:518px;
    height:166px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
  }
  .part5_item1{
    box-sizing: border-box;
    padding: 80px 0 60px 0;
  }
  .part5_item_txt4{
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    width: 100%;
  }
  .part5_item2{
    width: 100%;
    box-sizing: border-box;
    padding: 60px 0 80px 0;
    display: flex;
  }
  .part5_item2txtBox{
    flex: 1;
    background:rgba(229,236,255,1);
    font-size:16px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(59,74,117,1);
    line-height:30px;
    box-sizing: border-box;
    padding: 0 100px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .part5_item2_cell{
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    padding: 15px 0;
  }
  .part5_item2_cell>div:nth-of-type(1){
    flex: 1;
  }
  .part5_item2_cell>div:nth-of-type(2){
    width: 210px;
  }
  .part5_item2Squ{
    display: inline-block;
    width:10px;
    height:10px;
    border:2px solid rgba(42,98,255,1);
    border-radius:50%;
    margin: 0 20px 0 0;
  }
  .part5_item2_txt1{
    display: flex;
  }
  .part5_item2_txt1>span:nth-of-type(1){
    box-sizing: border-box;
    margin: 10px 20px 0 0;
  }
  .part5_item2_txt1>span:nth-of-type(2){
    flex: 1;
  }
  .part5_item3{
    background: #ffffff;
    padding: 0 60px 0 0;
  }
  .part3_tabImg{
    width: 100%;
    padding: 40px 0;
  }
</style>




// WEBPACK FOOTER //
// src/components/info/pipeEliminator.vue